import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { modulo12 } from "../../../routes/Module12";
import Sidebar from "../Sidebar";
import { faComments } from "@fortawesome/free-solid-svg-icons";
import Imagen1 from "../../../images/modulo12/hablarmal.png";
import Imagen2 from "../../../images/modulo12/hojacuaderno.png";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo12/Unidad1Actividad7.mp3";

const Actividad9 = () => {
  const infoUnidad = modulo12.content[0];
  const infoAct = modulo12.content[0].activities[8];
  const crumbs = [
    {
      title: modulo12.title,
      url: "/" + modulo12.url,
    },
    {
      title:
        modulo12.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo12.content[0].name}: ${modulo12.content[0].activities[9].name}`,
    linkNext: `${modulo12.url}/${modulo12.content[0].path}/${modulo12.content[0].activities[9].path}`,
    titlePrev: `${modulo12.content[0].name}: ${modulo12.content[0].activities[7].name}`,
    linkPrev: `${modulo12.url}/${modulo12.content[0].path}/${modulo12.content[0].activities[7].path}`,
  };

  const metadata = {
    color: modulo12.color,
    title: `${modulo12.title} - ${infoAct.name}`,
    name: modulo12.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo12.color} hat-text`}>
          <FontAwesomeIcon icon={faComments} /> Dialogamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <ul className="">
        <li>Mira esta viñeta.</li>
      </ul>
      <div className="text-center">
        <img src={Imagen1} className="img-fluid" alt="Peruanos" />
      </div>

      <ul className="mb-0 mt-5">
        <li>
          Escoge un amigo, amiga o familiar y conversen sobre esto: ¿por qué la
          niña no quiere jugar con Eli?
        </li>
      </ul>

      <img src={Imagen2} className="img-fluid my-4" alt="Peruanos" />
      <ul>
        <li>
          Escojan una de las razones y conversa con un compañero, compañera o
          familiar: ¿por qué les parece una buena razón?
        </li>
      </ul>
      <div className="row">
        <div className="col-md-10 col-12">
          <textarea rows={3} className="form-control" />
        </div>
      </div>
      <GuiaDocente>
        <ul>
          <li>
            Lea la primera indicación: Mira esta viñeta. A continuación, pida al
            niño o niña que lea el texto de la historieta: “A Eli no la llames,
            que seguro ella no sabe jugar. En su pueblo no conocen este juego”.
          </li>

          <li>
            Lea la segunda indicación: Escoge un amigo, amiga o familiar y
            conversen sobre esto: ¿por qué la niña no quiere jugar con Eli?
          </li>

          <li>
            Pida que discutan acerca de esta pregunta. Para ello, puede
            proponerles que respondan oralmente a estas preguntas:
            <ul>
              <li>
                <i>
                  “¿Qué está sucediendo entre las niñas? ¿Por qué creen que las
                  niñas no dejan jugar a Eli? ¿Qué piensan ustedes sobre ello y
                  por qué?”
                </i>
              </li>
            </ul>
          </li>

          <li>
            Retome algunas respuestas de los niños y niñas. Converse con ellos
            sobre cuál es la situación que se muestra en la imagen. Debe quedar
            claro que las niñas están discriminando a Eli por ser de otro lugar
            y con ello la excluyen del juego.
          </li>

          <li>
            Pida que lean las tres razones que aparecen en la hoja de papel.
          </li>

          <li>
            Lea la indicación: Escojan una de las razones y conversen entre
            ustedes: ¿por qué les parece una buena razón?
          </li>

          <li>
            Explique que el objetivo es encontrar argumentos por los cuales la
            razón elegida es pertinente. Todas las razones presentadas son
            adecuadas, no se trata de encontrar una mejor que otra.
          </li>

          <li>
            Pida que expongan sus ideas. No es necesario llegar a un consenso
            entre todos, pero sí se debe dejar en claro que la exclusión trae
            consecuencias negativas tanto para el excluido como para el grupo
            que lo excluye.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad9;
